import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import './Medcall2ParticipantStatusPopover.css';

type StatusDraft = { reason: string; otherReason: string; activationBackDate: string };

type Props = {
  children: React.ReactElement;
  draft: StatusDraft;
  maxDate: string;
  minDate: string;
  onCancel: () => void;
  onChange: (draft: StatusDraft) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  open: boolean;
  pending: boolean;
  reasons: readonly string[];
};

export const Medcall2ParticipantStatusPopover = ({
  children, draft, maxDate, minDate, onCancel, onChange, onSubmit, open, pending, reasons,
}: Props) => (
  <Popover.Root open={open} onOpenChange={(nextOpen) => { if (!nextOpen && !pending) onCancel(); }}>
    <Popover.Anchor asChild>{children}</Popover.Anchor>
    <Popover.Portal>
      <Popover.Content
        aria-label="Deactivate Client"
        className="medcall2-status-popover"
        onOpenAutoFocus={(event) => event.preventDefault()}
        side="bottom"
        sideOffset={4}
      >
        <div className="medcall2-status-popover__title">Select the reason for deactivation</div>
        <form onSubmit={onSubmit}>
          <Select disabled={pending} onValueChange={(reason) => onChange({ ...draft, reason })} value={draft.reason}>
            <SelectTrigger aria-label="Deactivation reason" id="medcall2-status-reason"><SelectValue /></SelectTrigger>
            <SelectContent>
              {reasons.map((reason) => <SelectItem key={reason} value={reason}>{reason}</SelectItem>)}
            </SelectContent>
          </Select>
          {draft.reason === 'Other' ? (
            <Input
              aria-label="Other reason"
              disabled={pending}
              id="medcall2-status-other-reason"
              onChange={(event) => onChange({ ...draft, otherReason: event.target.value })}
              placeholder="Please enter the reason"
              required
              value={draft.otherReason}
            />
          ) : null}
          <label htmlFor="medcall2-status-date">Select disable date:</label>
          <Input
            disabled={pending}
            id="medcall2-status-date"
            max={maxDate}
            min={minDate}
            onChange={(event) => onChange({ ...draft, activationBackDate: event.target.value })}
            type="date"
            value={draft.activationBackDate}
          />
          <div className="medcall2-status-popover__actions">
            <Button disabled={pending} id="medcall2-status-cancel" onClick={onCancel} type="button" variant="outline">Cancel</Button>
            <Button
              disabled={pending || (draft.reason === 'Other' && !draft.otherReason)}
              id="medcall2-status-submit"
              type="submit"
            >Deactivate Client</Button>
          </div>
        </form>
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
);
